export default class MiniMagnet {
    constructor() {
        this.$root = document.getElementById('miniMagnet');

        this.cookie = costorage.get('h_miniMagnet');
        this.showDelay = 30000;

        this.init();
    }

    init() {
        if (this.$root == null || this.cookie || !window.matchMedia('(min-width: 769px)').matches) {
            return;
        }

        this.$close = this.$root.querySelector('.mini-magnet_close');
        this.$links = this.$root.querySelectorAll('.mini-magnet-link');

        this.$close.addEventListener('click', this.hide.bind(this));
        this.$links.forEach($link => {
            $link.addEventListener('click', this.handleLinkClick.bind(this));
        });

        setTimeout(() => {
            this.show();
        }, this.showDelay);
    }

    setCookie() {
        costorage.set('h_miniMagnet', 1, {
            expires: 45 * 24 * 60 * 60,
            domain: '.bookford.com',
            path: "/"
        });
    }

    handleLinkClick(e) {
        e.preventDefault();
        this.setCookie();
        location.href = e.currentTarget.href;
    }

    show() {
        this.$root.style.display = null;
        setTimeout(() => {
            this.$root.classList.add('-show');
        }, 20);
    }

    hide() {
        this.$root.classList.remove('-show');
        this.setCookie();
    }
}